module.exports = __webpack_public_path__ + "img/feyenoord.cb9fe879.png";